import { useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  ListProductLinkedStockInput,
  ListProductLinkedStockResult,
} from 'services/interface/productLinkedStock.interface'
import { listProductLinkedStock } from 'services/productApi'

export const useListProductLinkedStock = (
  input: ListProductLinkedStockInput,
  enabled: boolean
): UseQueryResult<ListProductLinkedStockResult, Error> =>
  useQuery({
    queryKey: ['productLinkedStock', 'list', input],
    queryFn: () => listProductLinkedStock(input),
    enabled: enabled && !!(input.sku_id || input.product_id),
  })
